import _slicedToArray from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _typeof from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/web.dom.iterable";
import _objectSpread from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es6.array.find";
import _createForOfIteratorHelper from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line no-unused-vars
import { DEP_CONFIG, ROLE_CONFIG, CONFIG_LIST } from "./config.js";
import { debounce } from '@/assets/utils/index.js';
export default {
  name: 'FcOrgTransfer',
  props: {
    // v-model 已经选择过的数据 用于回显
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 字符串数组使用配置文件的预设值
    // 对象数组需要包含 key/conf 两个属性 conf 会覆盖对应key的默认配置
    tabList: {
      type: Array,
      default: function _default() {
        return ['dep', 'role'];
      }
    },
    title: {
      type: String,
      default: '组织机构'
    },
    show: {
      type: Boolean,
      reuired: true
    },
    // 是否支持模糊查询
    searchable: {
      type: Boolean,
      default: true
    },
    // 可选择的最大数量
    maxNum: {
      type: Number,
      default: 99
    }
  },
  data: function data() {
    return {
      searchRes: [],
      // 搜索后的结果
      selectedData: [],
      // 用户手动选择的节点(在tree里面已经显示的节点)
      aloneCheckedData: [],
      // 已有的 但是未在tree中渲染的数据 例如回显时的数据
      isEnough: false,
      // 是否选择了足够的人数
      searchString: '',
      searchMode: false,
      // 是否展示搜索面板
      searchLoading: false,
      activeTabName: '',
      tabConfig: [],
      tabKeys: []
    };
  },
  computed: {
    selectedNum: function selectedNum() {
      var num = 0;
      var _iterator = _createForOfIteratorHelper(this.tabKeys),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          var data1 = this.selectedData[key];
          data1 && data1.length && (num += data1.length);
          var data2 = this.aloneCheckedData[key];
          data2 && data2.length && (num += data2.length);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return num;
    }
  },
  watch: {
    searchString: function searchString(newVal) {
      this.searchMode = !!newVal;
      this.debounceSearch();
    },
    show: {
      handler: function handler(show) {
        show && this.dataInit() && this.isNumEnough();
      },
      immediate: true
    },
    tabList: {
      handler: function handler(val) {
        this.dataInit(); // tablist 比show 延后
      },

      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {
    this.isNumEnough();
    this.debounceSearch = debounce(this.searchDepUser, 500);
  },
  methods: {
    onLoad: function onLoad(node, resolve) {
      var _this = this;
      var conf = this.tabConfig.find(function (t) {
        return t.tabKey === _this.activeTabName;
      });
      // load 方法返回一个promise
      conf.onload(node).then(function (res) {
        var nodes = res.map(function (t) {
          return _objectSpread({
            nodeId: conf.nodeId(t)
          }, t);
        });
        resolve(nodes);
      }).then(function (res) {
        var _iterator2 = _createForOfIteratorHelper(_this.tabKeys),
          _step2;
        try {
          var _loop = function _loop() {
            var tabKey = _step2.value;
            var tree = _this.$refs[tabKey][0];
            _this.aloneCheckedData[tabKey].forEach(function (data) {
              tree.setChecked(data.nodeId, true);
            });
          };
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      });
    },
    searchDepUser: function searchDepUser() {
      var _this2 = this;
      if (!this.searchString) {
        this.searchRes = [];
        return;
      }
      this.searchLoading = true;
      var activeConfig = this.getActiveConf();
      new Promise(function (resolve, reject) {
        activeConfig.onsearch(_this2.searchString, resolve, reject);
      }).then(function (res) {
        _this2.searchRes = res.map(function (t) {
          return _objectSpread({
            nodeId: activeConfig.nodeId(t)
          }, t);
        });
      }).catch(function (err) {
        return console.warn(err);
      })
      // eslint-disable-next-line no-return-assign
      .finally(function () {
        return _this2.searchLoading = false;
      });
    },
    onCheckChange: function onCheckChange(data, checked, tabKey) {
      var _this3 = this;
      this.activeTabName = tabKey;
      var index = this.aloneCheckedData[tabKey].findIndex(function (t) {
        return t.nodeId === data.nodeId;
      });
      if (index > -1) {
        this.aloneCheckedData[tabKey].splice(index, 1);
      }
      this.$nextTick(function () {
        var tree = _this3.$refs[tabKey][0];
        var nodes = tree.getCheckedNodes().map(function (t) {
          !t.nodeId && (t.nodeId = _this3.getNodeProp(t, 'nodeId', _this3.activeTabName));
          return t;
        });
        _this3.$set(_this3.selectedData, _this3.activeTabName, nodes);
        _this3.isNumEnough();
        _this3.$forceUpdate();
      });
    },
    addData: function addData(data) {
      var tabKey = this.activeTabName;
      var tree = this.$refs[tabKey][0];
      tree.setChecked(data.nodeId, true);
      !tree.getCheckedKeys(data).includes(data.nodeId) && !this.aloneCheckedData[tabKey].find(function (t) {
        return t.nodeId === data.nodeId;
      }) && this.aloneCheckedData[tabKey].push(data);
    },
    removeData: function removeData(data, tabKey) {
      var fromAloneData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (fromAloneData) {
        var index = this.aloneCheckedData[tabKey].findIndex(function (t) {
          return t.nodeId === data.nodeId;
        });
        index > -1 && this.aloneCheckedData[tabKey].splice(index, 1);
      } else {
        this.$refs[tabKey][0].setChecked(data.nodeId, false); // 触发onCheckChange
      }
    },
    removeAll: function removeAll() {
      var _this4 = this;
      var _iterator3 = _createForOfIteratorHelper(this.tabKeys),
        _step3;
      try {
        var _loop2 = function _loop2() {
          var type = _step3.value;
          var tree = _this4.$refs[type][0];
          tree.getCheckedKeys().forEach(function (key) {
            tree.setCheckedKeys([]);
          });
          _this4.selectedData[type] = [];
          _this4.aloneCheckedData[type] = [];
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    },
    isNumEnough: function isNumEnough() {
      var count = 0;
      var _iterator4 = _createForOfIteratorHelper(this.tabKeys),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var type = _step4.value;
          count += this.selectedData[type].length;
          count += this.aloneCheckedData[type].length;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this.isEnough = count >= this.maxNum;
    },
    closeTransfer: function closeTransfer() {
      this.$emit('update:show', false);
      this.tabKeys = [];
      this.isEnough = false;
      this.searchString = '';
    },
    confirm: function confirm() {
      var res = {};
      var _iterator5 = _createForOfIteratorHelper(this.tabKeys),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var type = _step5.value;
          res[type] = this.selectedData[type].concat(this.aloneCheckedData[type]);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      this.$emit('confirm', res);
      this.closeTransfer();
    },
    getActiveConf: function getActiveConf(tabKey) {
      var target = tabKey || this.activeTabName;
      return this.tabConfig.find(function (t) {
        return t.tabKey === target;
      });
    },
    getConfProp: function getConfProp(propName, tabKey) {
      var conf = this.getActiveConf(tabKey);
      return conf ? conf[propName] : null;
    },
    getNodeProp: function getNodeProp(data, propName, tabKey) {
      try {
        var prop = this.getConfProp(propName, tabKey);
        if (typeof prop === 'string') {
          return data[prop];
        }
        if (typeof prop === 'function') {
          return prop(data);
        }
      } catch (e) {
        console.error(e);
        return '执行出错，可联系开发人员';
      }
    },
    dataInit: function dataInit() {
      var _this5 = this;
      this.aloneCheckedData = {};
      this.selectedData = {};
      this.tabConfig = [];
      this.tabKeys = [];
      var getTabProp = function getTabProp(tabItem) {
        return _typeof(tabItem) === 'object' ? [tabItem.key, tabItem.config] : [tabItem, {}];
      };
      var initDefaultData = function initDefaultData(key, mergedConfig) {
        _this5.tabConfig.push(mergedConfig);
        _this5.tabKeys.push(key);
        var data = _this5.value && _this5.value[key] ? _this5.value[key] : [];
        data = data.map(function (t) {
          return _objectSpread({
            nodeId: mergedConfig.nodeId(t)
          }, t);
        });
        _this5.$set(_this5.aloneCheckedData, key, data);
      };
      this.tabList.forEach(function (item) {
        var _getTabProp = getTabProp(item),
          _getTabProp2 = _slicedToArray(_getTabProp, 2),
          key = _getTabProp2[0],
          customConf = _getTabProp2[1];
        _this5.$set(_this5.aloneCheckedData, key, []);
        _this5.$set(_this5.selectedData, key, []);
        var defaultConf = CONFIG_LIST.find(function (t) {
          return t.tabKey === key;
        });
        defaultConf && initDefaultData(key, Object.assign({}, defaultConf, customConf));
      });
      this.activeTabName = this.tabKeys[0];
    }
  }
};